module.exports = __webpack_public_path__ + "assets/icon-magnifying-glass.732e5ba2.svg";